import * as React from "react";
import { Dialog, DialogContent, Typography, DialogContentText } from "@material-ui/core/";

import ButtonClose from "../../../../../../../../../../../util/buttonClose/.mixins/buttonClose";

//css
import StylesCss from "./styles";
const useStyles = StylesCss();

export default ({
    open,

    handleClose,
}) => {
    const classes = useStyles();

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <Typography align={"center"} className={classes.root}>
                NOVA DATA SUGERIDA
                <ButtonClose closeMethod={handleClose} />
            </Typography>
        <div className={classes.root} align="center">
                <Typography variant="subtitle1" align="center" gutterBottom>
                    <strong>A data escolhida foi sugerida com sucesso!</strong>
                </Typography>
                <Typography variant="subtitle1" align="center">
                    Caso a data sugerida para o novo agendamento não esteja disponivel, a Tok&Stok
                    entrará em contato.
                </Typography>
            </div>
        </Dialog>
    );
};
